import { styled } from '@mui/material/styles';
import { Box, Paper, TextField, Typography } from '@mui/material';

export const SidebarWrapper = styled(Paper)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  margin: theme.spacing(0.625),
  padding: theme.spacing(1.25),
  backgroundColor: theme.palette.grey[50],
  borderRadius: theme.shape.borderRadius,
  width: '35%',
}));

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: '1.1rem',
  color: 'var(--primary-dark)',
  marginBottom: theme.spacing(2.5),
  textAlign: 'center',
}));

export const InputWrapper = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(1.875),
}));

export const Label = styled(Typography)(({ theme }) => ({
  fontSize: '1rem',
  color: 'var(--primary-dark)',
  marginBottom: theme.spacing(0.625),
  display: 'block',
}));

export const StyledInput = styled(TextField)(({ theme }) => ({
  width: '100%',
  '& .MuiOutlinedInput-root': {
    '&:hover fieldset': {
      borderColor: 'var(--secondary-dark)',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'var(--secondary-dark)',
      boxShadow: `0 0 5px ${theme.palette.primary.main}40`,
    },
  },
})); 